import { GlobalIcon } from "get-life-storybook-ts";

// Self-service policy modifications: backend only supports ES and AXA WL.
export const MODIFICATIONS_DOMAINS = ["es", "wl_es"];

export const modificationsAvailable = (domain?: string): boolean =>
  MODIFICATIONS_DOMAINS.includes(domain ?? "");

// Theme accent: falls back to the Life5 blue on ES; on AXA WL App.js injects
// --primary-color (#1943A0) so the whole section tints automatically.
export const ACCENT = "var(--primary-color, #423EF4)";
export const ACCENT_SOFT = "var(--light-primary-color, #eef2ff)";

export const fieldLabelStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  margin: "0 0 6px",
};

export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 15,
  color: "#111827",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

export const errorTextStyle: React.CSSProperties = {
  fontSize: 13,
  color: "#dc2626",
  margin: "6px 0 0",
};

export const Field = ({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
}) => (
  <div style={{ marginBottom: 14 }}>
    <p style={fieldLabelStyle}>{label}</p>
    {children}
    {error ? <p style={errorTextStyle}>{error}</p> : null}
  </div>
);

interface ModificationModalProps {
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: number;
}

export const ModificationModal = ({
  onClose,
  children,
  maxWidth = 560,
}: ModificationModalProps) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 1000,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 16,
    }}
    onClick={onClose}
  >
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 16,
        width: "100%",
        maxWidth,
        maxHeight: "90vh",
        overflow: "auto",
        padding: "32px 28px",
        position: "relative",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          border: "none",
          background: "none",
          cursor: "pointer",
          padding: 6,
          borderRadius: 6,
          display: "flex",
        }}
        aria-label="Cerrar"
      >
        <GlobalIcon iconName="XIcon" size="XS" color="#9ca3af" />
      </button>
      {children}
    </div>
  </div>
);

export const modalTitleStyle: React.CSSProperties = {
  fontSize: 20,
  fontWeight: 700,
  color: "#1e293b",
  margin: "0 0 8px",
  lineHeight: 1.4,
  paddingRight: 24,
};

export const modalDescStyle: React.CSSProperties = {
  fontSize: 14,
  color: "#64748b",
  lineHeight: 1.6,
  margin: "0 0 20px",
};

export const summaryBoxStyle: React.CSSProperties = {
  backgroundColor: "#f9fafb",
  borderRadius: 10,
  border: "1px solid #e5e7eb",
  padding: "14px 16px",
  marginBottom: 20,
};

export const summaryRowStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  fontSize: 14,
  padding: "4px 0",
};

export const SummaryRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <div style={summaryRowStyle}>
    <span style={{ color: "#6b7280" }}>{label}</span>
    <span style={{ color: "#111827", fontWeight: 600, textAlign: "right" }}>
      {value}
    </span>
  </div>
);

